import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';
import CurrencySetting from './tabs/currency';
import CostChanges from './tabs/costChanges';
import ProductTypes from './tabs/product';
import PrintingOptions from './tabs/printingOptions';
import PosOptions from './tabs/posOptions';
import Language from './tabs/language';


function GeneralSetting(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, refProductData, devData } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;


  const items = [
    {
      key: '1',
      label: 'Currency',
      children: <CurrencySetting/>,
    },
    {
      key: '2',
      label: 'Cost Changes',
      children: <CostChanges/>,
    },
    {
      key: '3',
      label: 'Product',
      children: <ProductTypes/>,
    },
    {
      key: '4',
      label: 'Printing Options',
      children: <PrintingOptions/>,
    },
    {
      key: '5',
      label: 'Language',
      children: <Language/>,
    },
    {
      key: '6',
      label: 'POS Options',
      children: <PosOptions/>,
    },
  ];


  const onChange = (key) => {
 
  };

  return (

    <div style={{alignItems: 'center'}}>
      <Tabs defaultActiveKey="1" centered={true} items={items} onChange={onChange} />
    </div>

  )
}

export default GeneralSetting;
